// ABOUTME: Coordinates parser operation list refresh after asynchronous CV extraction.
// ABOUTME: Keeps stale parser item rows updating without overlapping refresh requests.
import { apiDirectCall } from "customHooks/useApi";
import { shouldRefreshParserOperationItems } from "./parserItemActions";

type RefreshParserListParams = {
    operationId: string;
    companyId: string | number;
    postAddressSearch: string;
    refreshList: () => void | Promise<void>;
};

type RefreshParserListResult = {
    shouldKeepRefreshing: boolean;
    currentStatus?: string;
};

export const refreshParserListWhenOperationIsActive = async ({
    operationId,
    companyId,
    postAddressSearch,
    refreshList
}: RefreshParserListParams): Promise<RefreshParserListResult> => {
    const requestParams = {
        operationid: operationId,
        companyId
    };
    const operationResult = await apiDirectCall(
        postAddressSearch,
        "post",
        requestParams
    );
    const currentStatus =
        operationResult?.data?.data?.Items?.[0]?.status?.value;
    const shouldKeepRefreshing =
        shouldRefreshParserOperationItems(currentStatus);

    await Promise.resolve(refreshList());

    return {
        shouldKeepRefreshing,
        currentStatus
    };
};
